<template>
    <AppLoadingContainer :predicate="!isLoaded">
        <div class="card-body">
          <organization-business-role-section :organization-business-roles="organizationBusinessRoles"
                                              :organization-id="organizationId">
          </organization-business-role-section>
        </div>
        <div class="card-footer d-print-none text-right">
            <RouterLink :to="{name:'Organizations'}" class="btn btn-danger">Back</RouterLink>
        </div>
    </AppLoadingContainer>
</template>

<script>
    import OrganizationService from "../../services/OrganizationService";
    import OrganizationBusinessRoleSection from "@/components/organizations/OrganizationBusinessRoleSection";
    import AppLoadingContainer from "../shared/AppLoadingContainer";
    import {ApplicationRole} from "@/services/models/Role";

    export default {
        components: {
            AppLoadingContainer,
            OrganizationBusinessRoleSection
        },
        data() {
            return {
                isLoaded: false,
                organizationBusinessRoles: [],
            }
        },
        props: {
            organizationId: {
                type: String,
                required: true
            }
        },
        methods: {
            /**
             * @description Reloads the data
             */
            onCreate() {
                this.loadData();
            },

            /**
             * @description Loads the organization business roles
             */
            loadData() {
                const vm = this;
                vm.isLoaded = false;

                OrganizationService.getOrganizationBusinessRoles()
                    .then(response => {
                        vm.organizationBusinessRoles = response;
                    }).catch(() => {
                    vm.redirectToError();
                }).finally(() => {
                    vm.isLoaded = true;
                })
            }
        },
        created() {
            this.loadData();
        }
    }
</script>
